// extracted by mini-css-extract-plugin
module.exports =  {"fullscreen":"_25d45facb5--fullscreen--mfCte","no-print":"_25d45facb5--no-print--WH57H"};